import Vue from 'vue';

// import Pagination from 'element-ui/lib/pagination';
import Dialog from 'element-ui/lib/dialog';
// import Autocomplete from 'element-ui/lib/autocomplete';
import Dropdown from 'element-ui/lib/dropdown';
import DropdownMenu from 'element-ui/lib/dropdown-menu';
import DropdownItem from 'element-ui/lib/dropdown-item';
import Menu from 'element-ui/lib/menu';
import Submenu from 'element-ui/lib/submenu';
import MenuItem from 'element-ui/lib/menu-item';
import MenuItemGroup from 'element-ui/lib/menu-item-group';
import Input from 'element-ui/lib/input';
import InputNumber from 'element-ui/lib/input-number';
import Radio from 'element-ui/lib/radio';
import RadioGroup from 'element-ui/lib/radio-group';
import RadioButton from 'element-ui/lib/radio-button';
import Checkbox from 'element-ui/lib/checkbox';
// import CheckboxButton from 'element-ui/lib/checkbox-button';
import CheckboxGroup from 'element-ui/lib/checkbox-group';
// import Switch from 'element-ui/lib/switch';
import Select from 'element-ui/lib/select';
import Option from 'element-ui/lib/option';
import OptionGroup from 'element-ui/lib/option-group';
import Button from 'element-ui/lib/button';
import ButtonGroup from 'element-ui/lib/button-group';
// import Table from 'element-ui/lib/table';
// import TableColumn from 'element-ui/lib/table-column';
// import DatePicker from 'element-ui/lib/date-picker';
// import TimeSelect from 'element-ui/lib/time-select';
// import TimePicker from 'element-ui/lib/time-picker';
import Popover from 'element-ui/lib/popover';
import Tooltip from 'element-ui/lib/tooltip';
// import Breadcrumb from 'element-ui/lib/breadcrumb';
// import BreadcrumbItem from 'element-ui/lib/breadcrumb-item';
import Form from 'element-ui/lib/form';
import FormItem from 'element-ui/lib/form-item';
import Tabs from 'element-ui/lib/tabs';
import TabPane from 'element-ui/lib/tab-pane';
import Tag from 'element-ui/lib/tag';
// import Tree from 'element-ui/lib/tree';
import Alert from 'element-ui/lib/alert';
// import Slider from 'element-ui/lib/slider';
import Icon from 'element-ui/lib/icon';
import Row from 'element-ui/lib/row';
import Col from 'element-ui/lib/col';
// import Upload from 'element-ui/lib/upload';
import Progress from 'element-ui/lib/progress';
// import Badge from 'element-ui/lib/badge';
import Card from 'element-ui/lib/card';
// import Rate from 'element-ui/lib/rate';
import Steps from 'element-ui/lib/steps';
import Step from 'element-ui/lib/step';
// import Carousel from 'element-ui/lib/carousel';
// import CarouselItem from 'element-ui/lib/carousel-item';
// import Collapse from 'element-ui/lib/collapse';
// import CollapseItem from 'element-ui/lib/collapse-item';
// import Cascader from 'element-ui/lib/cascader';
// import ColorPicker from 'element-ui/lib/color-picker';
import Container from 'element-ui/lib/container';
import Header from 'element-ui/lib/header';
import Aside from 'element-ui/lib/aside';
import Main from 'element-ui/lib/main';
import Footer from 'element-ui/lib/footer';
import Loading from 'element-ui/lib/loading';
import MessageBox from 'element-ui/lib/message-box';
import Message from 'element-ui/lib/message';
import Notification from 'element-ui/lib/notification';

// Set up the locale of element-ui
import lang from 'element-ui/lib/locale/lang/en';
import locale from 'element-ui/lib/locale';

locale.use(lang);

// Vue.use(Pagination);
Vue.use(Dialog);
// Vue.use(Autocomplete);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Menu);
Vue.use(Submenu);
Vue.use(MenuItem);
Vue.use(MenuItemGroup);
Vue.use(Input);
Vue.use(InputNumber);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(RadioButton);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
// Vue.use(Switch);
Vue.use(Select);
Vue.use(Option);
Vue.use(OptionGroup);
Vue.use(Button);
Vue.use(ButtonGroup);
// Vue.use(Table);
// Vue.use(TableColumn);
// Vue.use(DatePicker);
// Vue.use(TimeSelect);
// Vue.use(TimePicker);
Vue.use(Popover);
Vue.use(Tooltip);
// Vue.use(Breadcrumb);
// Vue.use(BreadcrumbItem);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Tag);
// Vue.use(Tree);
Vue.use(Alert);
// Vue.use(Slider);
Vue.use(Icon);
Vue.use(Row);
Vue.use(Col);
// Vue.use(Upload);
Vue.use(Progress);
// Vue.use(Badge);
Vue.use(Card);
// Vue.use(Rate);
Vue.use(Steps);
Vue.use(Step);
// Vue.use(Carousel);
// Vue.use(CarouselItem);
// Vue.use(Collapse);
// Vue.use(CollapseItem);
// Vue.use(Cascader);
// Vue.use(ColorPicker);
Vue.use(Container);
Vue.use(Header);
Vue.use(Aside);
Vue.use(Main);
Vue.use(Footer);

Vue.prototype.$loading = Loading.service;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$notify = Notification;
Vue.prototype.$message = Message;

Vue.use(Loading.directive);



// WEBPACK FOOTER //
// ./src/utils/elementUiImporter.js